<template>
    <div class="header-box-menu-dropdown dropdown-lang" style="z-index: 9909; border: none;" @click="eventHutRewardsHeaderLink()">
        <dropdown menu-right>
          <button class="dropdown-toggle-header dropdown-toggle-login d-flex align-items-center"
            data-toggle="tooltip" :title="userInfo + ' (' + getSlicesUser() + ')'"
          >
            <template v-if="$auth.check()">
              <img class="image-reward-header pr-2" :src="iconRedSlice" width="27" />
              <p class="ellipsisTextHeader pr-2 mb-0">{{ $t('dear_name', { name: userInfo }) }}</p>
              <p class="ellipsisTextHeader mb-0">{{`(${getSlicesUser()})`}}</p>
              <i class="fa fa-angle-down fa-lg pl-2" aria-hidden="true"></i>
            </template>
            <template v-else>
              <!-- <img :src="logoHutRewards" alt="logo hut rewards" /> -->
              <img class="image-reward-header pr-2" :src="iconGraySlice" width="30" />
              <p class="ellipsisTextHeader pr-2 mb-0">{{ $t('header_home_title') }}</p>
              <i class="fa fa-angle-down fa-lg pl-2" aria-hidden="true"></i>
            </template>
          </button>
          <template slot="dropdown">
            <li
              class="dropdown-item item-menu-hut-rewards py-2 px-2 slice-number"
            >
              <router-link v-if="$auth.check()" :to="{name: 'hut_rewards'}">
                <img
                  src="https://static.phdvasia.com/jp/hut-rewards/pizza.png"
                  alt="icon-hut-rewards"
                  width="22"
                />
                <span class="ml-2 text-white">{{ getSlicesUser() }}</span>
              </router-link>
              <router-link v-else :to="{name: 'login'}" style="display: flex; align-items: center;">
                <!-- <img :src="logoHutRewardsWhite" alt="logo hut rewards" width="136" /> -->
                <img class="image-reward-header pr-2" :src="iconWhiteSlice" width="30" />
                <p class="ellipsisTextHeader xs-text-white pr-2 mb-0">{{ $t('header_home_title') }}</p>
              </router-link>
            </li>
            <template v-if="$auth.check()">
              <li
                class="dropdown-item item-label-hut py-2 px-2"
                v-for="(item, idx) in listDropdownUser"
                :key="idx"
                @click.stop="changeStatus(item)"
              >
                <a v-if="item.type" href="javascript:void(0)" @click="$root.$emit('logout')">{{item.title}}</a>
                <router-link v-else :to="item.path">{{item.title}}</router-link>
              </li>
            </template>
            <template v-else>
              <li
                class="dropdown-item item-label-hut py-2 px-2"
                v-for="(item, idx) in listDropdown"
                :key="idx"
                @click.stop="changeStatus(item)"
              >
                <router-link :to="item.path">{{item.title}}</router-link>
              </li>
            </template>
            <li class="dropdown-item item-label-hut py-2 px-2">
              <button-toggle-language />
            </li>
          </template>
        </dropdown>
  </div>
</template>

<script>
import ButtonToggleLanguage from '@/components/Buttons/ButtonToggleLanguage'
import * as types from '@/store/types'
import { mapGetters } from 'vuex'

export default {
  name: 'DropdownHeader',
  components: {
    ButtonToggleLanguage
  },
  computed: {
    ...mapGetters({
      hutReward: types.GET_HUT_REWARD
    })
  },
  data () {
    return {
      logoHutRewards:
        'https://static.phdvasia.com/jp/header/logo-hut-rewards.svg',
      logoHutRewardsWhite:
        'https://static.phdvasia.com/my/fcds/hutawards/hut-rewards.png',
      iconRedSlice: 'https://static.phdvasia.com/jp/header/icon-red-slice.svg',
      iconGraySlice: 'https://static.phdvasia.com/jp/header/icon-gray-slice.svg',
      iconWhiteSlice: 'https://static.phdvasia.com/jp/header/icon-white-slice.svg',
      expanded: false,
      userInfo: '',
      numberSlices: 0,
      listDropdown: [
        {
          title: this.$t('login_title'),
          path: {name: 'login'},
          key: 'login'
        },
        {
          title: this.$t('login_signup'),
          path: {name: 'register'},
          key: 'register'
        }
      ],
      listDropdownUser: [
        {
          title: this.$t('header.my_account_information'),
          path: {name: 'account_info'},
          key: 'account_info'
        },
        {
          title: this.$t('button_logout'),
          type: 'button',
          path: '',
          key: 'logout'
        }
      ]
    }
  },
  methods: {
    changeStatus (item) {
      this.expanded = !this.expanded
      switch (item.key) {
        case 'login':
          this.eventClickedLogin()
          break;
        case 'register':
          this.eventClickedSignUp()
          break;
        case 'account_info':
          this.eventHutRewardsMyAccount()
          break;
        case 'logout':
          this.eventHutRewardsLogout()
          break;
        default:
          break;
      }
    },
    getSlicesUser () {
      const slices = this.hutReward.rank ? this.hutReward.point : this.$auth.user().point
      return this.$tc('header.infoSlices', slices, {slice: slices})
    }
  },
  mounted () {
    if (this.$auth.check()) {
      this.userInfo = this.$auth.user().last_name
    }
    let vm = this
    this.$root.$on('resetSlicesHeader', () => {
      vm.getSlicesUser()
    })
  }
}
</script>

<style lang="scss" scoped>
#dropdownMenuLink {
  color: black;
}
.header-box-menu-dropdown {
  .item-menu-hut-rewards {
    background: #c8102e;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
}
.header-box-menu-dropdown {
  max-width: 220px;
  padding: 0px;
  .dropdown-item:first-child {
    text-align: center;
    a:hover {
      background: #c8102e;
    }
  }
  .dropdown-item {
    border-bottom: 1px solid #E9EBEE;
    a {
      padding: 3px 0px;
    }
    &.slice-number {
      text-align: left;
    }
    a:hover {
      background: transparent;
    }
  }
  .dropdown-item:last-child {
    border-bottom: none;
  }
  .dropdown-toggle-header {
    background: transparent;
    border: none;
    padding-left: 5px !important;
  }
  .dropdown-toggle-header.btn-default:active {
    background: transparent !important;
    box-shadow: none;
  }
  .dropdown-toggle-header.btn-default:focus {
    outline-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/DropdownHeader.vue